import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme должен быть использован внутри ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    // Загружаем тему из localStorage или используем 'dark' по умолчанию
    const saved = localStorage.getItem('theme');
    return saved || 'dark';
  });

  // Обновляем document класс и localStorage при изменении темы
  useEffect(() => {
    const html = document.documentElement;
    if (theme === 'light') {
      // Удаляем класс dark для Tailwind
      html.classList.remove('dark');
      html.classList.add('light');
    } else {
      // Добавляем класс dark для Tailwind
      html.classList.remove('light');
      html.classList.add('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
